import type WordpressSituation from '@gik/core/models/wordpress/WordpressSituation';

export function getSituationVariant(item: WordpressSituation, items: WordpressSituation[]) {
  if (!item) return undefined;
  // ----- assign a variant by parent
  if (item.parent) {
    const parentItem = items?.find(taxonomy => taxonomy.id === item.parent);
    return getSituationVariant(parentItem, items);
  }

  return item.acf.variant;
}
